var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgExit = function SvgExit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h36v36H0z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.755 5.4H21.6v2.7L8.123 8.054v19.892L21.6 27.9v2.654L6.755 30.6A1.336 1.336 0 0 1 5.4 29.273V6.727c0-.73.61-1.327 1.355-1.327Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.072 23.912-1.91-1.898 2.783-2.68H16.494V16.68H26.93l-2.768-2.694 1.924-1.898 5.108 4.99c.257.252.406.597.406.942a1.314 1.314 0 0 1-.406.942l-5.122 4.95Z"
  })))));
};
export default SvgExit;